import { render } from "./OidoPopover.vue?vue&type=template&id=365b7a34"
import script from "./OidoPopover.vue?vue&type=script&lang=js"
export * from "./OidoPopover.vue?vue&type=script&lang=js"

import "./OidoPopover.vue?vue&type=style&index=0&id=365b7a34&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__